module.exports = __webpack_public_path__ + "static/aca_fct2-38800f6e39a46eb35a860bab1d43b29e.jpg";